export const initGDPRConsent = () => {
    window.dataLayer = window.dataLayer || [];

    const $gdprConsent = document.querySelector('.js-accept');

    const $gdprConsentContent = document.querySelector('.js-accept-content');
    const $gdprConsentToggleContent = document.querySelector('.js-accept-toggle-content');
    const $gdprConsentToggle = document.querySelector('.js-accept-toggle');

    const $gdprConsentSubmit = document.querySelector('.js-accept-submit');
    const $gdprConsentSave = document.querySelector('.js-accept-save');
    const $gdprNecessaryConsentSubmit = document.querySelector('.js-accept-necessary-save');

    const $toggleCheckboxes = document.querySelectorAll('.js-toggle-checkbox');

    const $gdprConsentShowAction = document.querySelector('.js-open-accept');

    const params = new URLSearchParams(window.location.search);

    const dataLayer = window.dataLayer;

    const domain = window.userDomain;

    const cookieName = 'entrio_cookie';

    const cookieNecessaryObject = {
        title: 'Necessary',
        id: 'REQ',
        checked: true
    };

    const cookieStatisticsObject = {
        title: 'Statistics',
        id: 'STATS',
        checked: false
    };

    const cookieMarketingObject = {
        title: 'Marketing',
        id: 'MARK',
        checked: false
    };

    clearOldCookies();

    if (!Boolean(params.get('hideGDPR'))) {
        if (document.cookie.indexOf(cookieName) === -1) {
            $gdprConsent.classList.add('is-shown');

            setTimeout(function() {
                $gdprConsent.classList.add('is-faded');
                document.querySelector('html').classList.add('with-open-accept');
            }, 300);
        } else {
            const cookie = getCookie(cookieName);
            let cookieArray = [];

            try {
                cookieArray = JSON.parse(cookie);
                $toggleCheckboxes.forEach((checkbox) => {
                    const closestTextEl = checkbox.nextElementSibling.nextElementSibling;
                    const currentCookie = cookieArray.find(cookie => cookie.id === checkbox.name);

                    checkbox.checked = currentCookie.checked;

                    if (closestTextEl) {
                        closestTextEl.innerText = currentCookie.checked ? 'On' : 'Off';
                    }
                });
            } catch (error) {
                console.error("Error parsing cookie JSON:", error);
                clearAndReissueCookie();
            }
        }
    }

    $gdprConsentToggle.addEventListener('click', event => {
        $gdprConsentContent.classList.toggle('with-expanded-content');
        event.target.classList.toggle('is-expanded');

        if (event.target.classList.contains('is-expanded')) {
            $gdprConsentToggleContent.style.height = `${$gdprConsentToggleContent.scrollHeight}px`;
        } else {
            $gdprConsentToggleContent.style.height = '0px';
        }
    })

    $toggleCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', event => {
            const closestTextEl = event.target.nextElementSibling.nextElementSibling;

            if (closestTextEl) {
                if (event.target.checked) {
                    closestTextEl.innerText = 'On';
                } else {
                    closestTextEl.innerText = 'Off';
                }
            }
        })
    });

    function setCookie(name, values, days) {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = `; expires=${date.toUTCString()}`;
        }
        const value = encodeURIComponent(JSON.stringify(values));
        document.cookie = `${name}=${(value || "")}${expires}; path=/`;
    }

    function getCookie(name) {
        const cookies = document.cookie.split("; ");
        for (let cookie of cookies) {
            const [key, value] = cookie.split("=");
            if (key === name) {
                try {
                    return decodeURIComponent(value);
                } catch (error) {
                    console.error("Received malformed JSON:", error);
                    clearAndReissueCookie();
                }
            }
        }
        return null;
    }

    function eraseCookie(name) {
        document.cookie =`${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    }

    initGtm();

    function activateGtm(a, c, d, e, E, f, g, i, I, m, n, o, r, t, v) {
        m = e;
        g =
            ((m[n] = m[n] || []),
                m[n].push({ "gtm.start": new Date().getTime(), event: "gtm.js" }),
                t.getElementsByTagName(r)[0]);

        v = I ? "&bi=" + encodeURIComponent(I) : "";
        E = t.createElement(r);

        f = (
            d && (i = i.length > 8 ? i.replace(/([a-z]{8}$)/, "kp$1") : "kp" + i),
                !d && a ? a : o
        );

        E.async = true;
        E.src = f + "/" + i + ".js?" + c + v;
        if ((e = g.parentNode) != null) e.insertBefore(E, g);
    }

    function setUpGoogleTagManager(hasStatistics = false, hasMarketing = false) {
        if (!domain) {
            console.error('Error while fetching the user domain');
            return;
        }

        let e = window;
        const t = document;
        const r = "script";
        const n = "dataLayer";
        const o = "https://a.entrio." + domain;
        const a = "";
        let i = "1tybhthhzh";
        const c = "6n6f944d=aWQ9R1RNLU01TTVMR0NC&apiKey=98d64a58";
        let g = "cookie";
        let v = "unique_visitor_id";
        let E = "";
        let d = false;
        let m;
        let f;
        let I;

        if (!window.gtmInitialized) {
            try {
                d =
                    !!g &&
                    ((m = navigator.userAgent),
                        !!(m = new RegExp("Version/([0-9._]+)(.*Mobile)?.*Safari.*").exec(m))) &&
                    16.4 <= parseFloat(m[1]);

                f = "stapeUserId" === g;
                I =
                    d && !f
                        ? (function (e, t, r) {
                            t === void 0 && (t = "");
                            const n = {
                                cookie: l,
                                localStorage: s,
                                jsVariable: u,
                                cssSelector: A
                            };
                            t = Array.isArray(t) ? t : [t];
                            if (e && n[e]) {
                                const o = n[e];
                                for (let a = 0, i = t; a < i.length; a++) {
                                    let c = i[a];
                                    c = r ? o(c, r) : o(c);
                                    if (c) return c;
                                }
                            } else {
                                console.warn("invalid uid source", e);
                            }
                        })(g, v, E)
                        : void 0;

                d = d && (!!I || f);
                activateGtm(a, c, d, e, E, f, g, i, I, m, n, o, r, t, v);
                window.gtmInitialized = true;
            } catch (error) {
                console.error('Error while activating Google Tag Manager', error);
            }
        }

        if (dataLayer && dataLayer.length) {
            if (hasStatistics) {
                dataLayer.push({
                    event: 'cookie_consent_statistics'
                });
            }

            if (hasMarketing) {
                dataLayer.push({
                    event: 'cookie_consent_marketing'
                });
            }
        }
    }

    function hideGdprPanel() {
        document.querySelector('html').classList.remove('with-open-accept');
        $gdprConsent.classList.remove('is-faded');

        setTimeout(function () {
            $gdprConsent.classList.remove('is-shown');

            $gdprConsentContent.classList.remove('with-expanded-content');
            $gdprConsentToggle.classList.remove('is-expanded');
            $gdprConsentToggleContent.style.height = '0px';
        }, 300);
    }

    $gdprConsentSubmit.addEventListener('click', event => {
        const cookieArray = [
            { ...cookieNecessaryObject },
            {
                ...cookieStatisticsObject,
                checked: true
            },
            {
                ...cookieMarketingObject,
                checked: true
            }
        ];

        setCookie(cookieName, cookieArray, 365);

        dataLayer.push({
            event: 'cookie_consent_functionality',
        });

        setUpGoogleTagManager(true, true);

        hideGdprPanel();
    })

    $gdprConsentSave.addEventListener('click', event => {
        let hasStatistics = false;
        let hasMarketing = false;

        const cookieArray = [{
            ...cookieNecessaryObject
        }];

        $toggleCheckboxes.forEach((checkbox) => {
            let cookieObject;
            switch (checkbox.name) {
                case 'STATS':
                    cookieObject = {
                        ...cookieStatisticsObject,
                        checked: checkbox.checked
                    };
                    hasStatistics = checkbox.checked;
                    break;
                case 'MARK':
                    cookieObject = {
                        ...cookieMarketingObject,
                        checked: checkbox.checked
                    };
                    hasMarketing = checkbox.checked;
                    break;
                default:
                    cookieObject = {
                        ...cookieNecessaryObject,
                        checked: checkbox.checked
                    };
                    break;
            }
            cookieArray.push(cookieObject);
        });

        setCookie(cookieName, cookieArray, 365);

        dataLayer.push({
            event: 'cookie_consent_functionality',
        });

        setUpGoogleTagManager(hasStatistics, hasMarketing);

        hideGdprPanel();
    })

    $gdprNecessaryConsentSubmit.addEventListener('click', event => {
        const cookieArray = [
            { ...cookieNecessaryObject },
            { ...cookieStatisticsObject },
            { ...cookieMarketingObject },
        ];

        setCookie(cookieName, cookieArray, 365);

        dataLayer.push({
            event: 'cookie_consent_functionality',
        });

        setUpGoogleTagManager();

        hideGdprPanel();
    })

    if ($gdprConsentShowAction !== null) {
        $gdprConsentShowAction.addEventListener('click', event => {
            const cookie = getCookie(cookieName);
            let cookieArray = [];

            try {
                cookieArray = JSON.parse(cookie);
            } catch (error) {
                console.error("Error parsing cookie JSON:", error);
                clearAndReissueCookie();
            }

            $toggleCheckboxes.forEach((checkbox) => {
                const closestTextEl = checkbox.nextElementSibling.nextElementSibling;
                const currentCookie = cookieArray.find(cookie => cookie.id === checkbox.name);

                checkbox.checked = currentCookie.checked;

                if (closestTextEl) {
                    closestTextEl.innerText = currentCookie.checked ? 'On' : 'Off';
                }
            });

            $gdprConsent.classList.add('is-shown');

            setTimeout(function() {
                $gdprConsent.classList.add('is-faded');
                document.querySelector('html').classList.add('with-open-accept');
            }, 300);
        });
    }

    function initGtm() {
        const cookie = getCookie(cookieName);
        let hasStatsCookie = false;
        let hasMarketingCookie = false;

        if (cookie) {
            let cookieArray = [];

            try {
                cookieArray = JSON.parse(cookie);
                cookieArray.forEach(cookie => {
                    if (cookie.id === 'STATS') {
                        hasStatsCookie = cookie.checked;
                    }

                    if (cookie.id === 'MARK') {
                        hasMarketingCookie = cookie.checked;
                    }
                })
            } catch (error) {
                console.error("Error parsing cookie JSON:", error);
                clearAndReissueCookie();
            }
        }

        setUpGoogleTagManager(hasStatsCookie, hasMarketingCookie);
    }

    function clearOldCookies() {
        const necessaryCookie = getCookie('entrio_gdpr_consent');
        const analyticsCookie = getCookie('entrio_analytics');
        const marketingCookie = getCookie('entrio_marketing');

        if (necessaryCookie) {
            eraseCookie('entrio_gdpr_consent');
        }

        if (analyticsCookie) {
            eraseCookie('entrio_analytics');
        }

        if (marketingCookie) {
            eraseCookie('entrio_marketing');
        }
    }

    function clearAndReissueCookie() {
        eraseCookie(cookieName);

        $gdprConsent.classList.add('is-shown');

        setTimeout(function() {
            $gdprConsent.classList.add('is-faded');
            document.querySelector('html').classList.add('with-open-accept');
        }, 300);
    }

    function l(e) {
        for (let t = e, r = 0, n = document.cookie.split(";"); r < n.length; r++) {
            const o = n[r].split("=");
            if (o[0].trim() === t) return o[1];
        }
    }

    function s(e) {
        return localStorage.getItem(e);
    }

    function u(e) {
        return window[e];
    }

    function A(e, t) {
        e = document.querySelector(e);
        return t ? (e == null ? void 0 : e.getAttribute(t)) : (e == null ? void 0 : e.textContent);
    }
};
